import React from 'react'
import styles from './Content.module.scss'
import { classNames } from '../common/utils'

const Content = ({ children, className }) => (
  <div className={classNames(styles.content, className)}>{children}</div>
)

const Center = ({ children, className }) => (
  <Content className={classNames(styles.center, className)}>{children}</Content>
)

Content.Center = Center

export default Content
